import { DateTime } from 'luxon';
import { INewsChatViewDTO } from '../../../libs/coreapi-dto/service/newsChat';

export const getNewsDate = (news: INewsChatViewDTO): DateTime => {
    const date = news.startDate ?? news.dateCreated;

    return date
        ? DateTime.fromISO(date.toString())
        : DateTime.invalid('No news date');
};